import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ServicioSeleccionado } from "app/main/apps/shared/models/servicio-seleccionado.model";
import { TotalServicios } from "app/main/apps/shared/models/total-servicios.model";

@Component({
    selector: "app-servicios-seleccionados",
    templateUrl: "./servicios-seleccionados.component.html",
    styleUrls: ["./servicios-seleccionados.component.scss"],
})
export class ServiciosSeleccionadosComponent implements OnInit {
    @Input() serviciosSeleccionados: ServicioSeleccionado[] = [];
    @Input() total: TotalServicios;

    @Output() quitarServicio: EventEmitter<{
        idServicio: number;
        idSucursal: number;
    }> = new EventEmitter();
    @Output()
    editarServicio: EventEmitter<ServicioSeleccionado> = new EventEmitter();
    constructor() {}

    ngOnInit(): void {}

    editar(servicioSeleccionado: ServicioSeleccionado) {
        //console.log(servicioSeleccionado);
        this.editarServicio.emit(servicioSeleccionado);
    }

    quitar(idServicio: number, idSucursal: number) {
        const data = {
            idServicio,
            idSucursal,
        };
        //console.log(data);
        this.quitarServicio.emit(data);
    }
}
